"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAuthStateChannel = getAuthStateChannel;
exports.default = _callee;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var types = _interopRequireWildcard(require("../../actionType"));

var _actions = require("../../actions");

var _circuits = require("./circuits");

var _marked =
/*#__PURE__*/
_regenerator.default.mark(tokenAvailabilityCircuit),
    _marked2 =
/*#__PURE__*/
_regenerator.default.mark(authSessionCircuit),
    _marked3 =
/*#__PURE__*/
_regenerator.default.mark(getAuthStateChannel),
    _marked4 =
/*#__PURE__*/
_regenerator.default.mark(_callee);

function tokenAvailabilityCircuit() {
  var tokenAvailabilityUnits;
  return _regenerator.default.wrap(function tokenAvailabilityCircuit$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          tokenAvailabilityUnits = [{
            pattern: types.SET_AUTH_TOKENS,
            task:
            /*#__PURE__*/
            _regenerator.default.mark(function task(action) {
              var token;
              return _regenerator.default.wrap(function task$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      token = action.tokens.accessToken.token;
                      _context.next = 3;
                      return (0, _effects.put)((0, _actions.accessTokenAvailable)(token));

                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }
              }, task, this);
            })
          }, {
            pattern: [types.AUTH_REFRESH_TOKEN, types.AUTH_LOGOUT],
            task:
            /*#__PURE__*/
            _regenerator.default.mark(function task() {
              return _regenerator.default.wrap(function task$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return (0, _effects.put)((0, _actions.accessTokenUnavailable)());

                    case 2:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, task, this);
            })
          }];
          _context3.next = 3;
          return (0, _effects.fork)(_circuits.simpleCircuit, tokenAvailabilityUnits);

        case 3:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked, this);
}

function authSessionCircuit() {
  var authSessionUnits, authSessionInterruptionUnits;
  return _regenerator.default.wrap(function authSessionCircuit$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          authSessionUnits = [{
            pattern: types.SET_AUTH_TOKENS,
            task:
            /*#__PURE__*/
            _regenerator.default.mark(function task() {
              return _regenerator.default.wrap(function task$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return (0, _effects.put)((0, _actions.authSessionStart)());

                    case 2:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, task, this);
            })
          }, {
            pattern: types.AUTH_LOGOUT,
            task:
            /*#__PURE__*/
            _regenerator.default.mark(function task() {
              return _regenerator.default.wrap(function task$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return (0, _effects.put)((0, _actions.authSessionEnd)());

                    case 2:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, task, this);
            })
          }];
          authSessionInterruptionUnits = [{
            pattern: types.AUTH_REFRESH_TOKEN,
            task:
            /*#__PURE__*/
            _regenerator.default.mark(function task() {
              return _regenerator.default.wrap(function task$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return (0, _effects.put)((0, _actions.authSessionPause)());

                    case 2:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, task, this);
            })
          }, {
            pattern: types.AUTH_REFRESH_TOKEN_SUCCESS,
            task:
            /*#__PURE__*/
            _regenerator.default.mark(function task() {
              return _regenerator.default.wrap(function task$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      _context7.next = 2;
                      return (0, _effects.put)((0, _actions.authSessionResume)());

                    case 2:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, task, this);
            })
          }];
          _context8.next = 4;
          return (0, _effects.fork)(_circuits.deepCircuit, [authSessionUnits[0]].concat(authSessionInterruptionUnits, [authSessionUnits[1]]));

        case 4:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked2, this);
}

function getAuthStateChannel() {
  var authStateChannel;
  return _regenerator.default.wrap(function getAuthStateChannel$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.actionChannel)([types.AUTH_SESSION_START, types.AUTH_SESSION_PAUSE, types.AUTH_SESSION_RESUME, types.AUTH_SESSION_END, types.ACCESS_TOKEN_AVAILABLE, types.ACCESS_TOKEN_UNAVAILABLE]);

        case 2:
          authStateChannel = _context9.sent;
          return _context9.abrupt("return", authStateChannel);

        case 4:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked3, this);
}

function _callee() {
  return _regenerator.default.wrap(function _callee$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.all)([tokenAvailabilityCircuit(), authSessionCircuit()]);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked4, this);
}